export enum GenderEnum {
    None = 0,
    Male = 1,
    Female = 2,
    PreferNotToSay = 3,
}
